import React from 'react'
import { Gift, X } from 'lucide-react'
import { useState, useEffect } from 'react'
import CookieManager from '../lib/CookiesManager'
import bannerConfig from '../data/banner.json'
import Cookies from 'js-cookie'

interface Translation {
  title: string
  description: string
}

interface BannerConfig {
  isActive: boolean
  translations: {
    [key: string]: Translation
  }
}

const BannerHomepage: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true)
  const [texts, setTexts] = useState<Translation | null>(null)

  useEffect(() => {
    const language = CookieManager.getLanguage() || 'fr-BE'
    const translations = (bannerConfig as BannerConfig).translations[language]

    if (translations) {
      setTexts(translations)
    } else {
      setTexts((bannerConfig as BannerConfig).translations['fr-BE'])
    }

    if (Cookies.get('bannerHided') === 'true') {
      setIsVisible(false)
    }
  }, [])

  if (!isVisible || !bannerConfig.isActive || !texts) {
    return null
  }

  return (
    <div className='relative w-full mx-auto bg-blue-200 rounded-lg text-white py-3 px-4 flex flex-col items-center text-center sm:py-4 sm:px-6'>
      <button
        onClick={() => {
          CookieManager.setBannerHided()
          setIsVisible(false)
        }}
        className='absolute top-2 right-2 text-anthracite hover:text-redpink'
        aria-label='Close banner'
      >
        <X className='h-5 w-5' />
      </button>

      <div className='flex flex-col items-center space-y-2 sm:flex-row sm:space-y-0 sm:space-x-4'>
        <Gift className='h-8 w-8 text-redpink animate-bounce' />

        <div className='flex flex-col items-center sm:items-center'>
          <h3 className='font-bold text-lg sm:text-xl'>{texts.title}</h3>
          <p className='text-sm text-gray-600'>{texts.description}</p>
        </div>
      </div>
    </div>
  )
}

export default BannerHomepage
